export default __webpack_public_path__ + "static/media/Sunday_07.d9aa02f3.png";